import {
    EnerbimCommonsAppInfoModule,
    EnerbimCommonsAuthenticationModule,
    EnerbimCommonsConfirmationModule,
    EnerbimCommonsDatepickerModule,
    EnerbimCommonsHttpModule,
    EnerbimCommonsMarkdownModule,
    EnerbimCommonsNotificationModule,
    EnerbimCommonsTreeModule,
    HttpErrorInterceptor,
    MatPaginatorI18nFr,
} from '@enerbim/commons-lib';
import {CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule, HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';

import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthExpiredInterceptor} from './shared/interceptor/auth-expired.interceptor';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {TreeModule} from 'angular-tree-component';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatListModule} from '@angular/material/list';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {GestureConfig} from '@angular/material/core';
import {MAT_TABS_CONFIG} from '@angular/material/tabs';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS} from '@angular/material/button-toggle';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {AppComponent} from 'app/app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HeaderComponent} from 'app/layout/header/header.component';
import {FooterComponent} from 'app/layout/footer/footer.component';
import {SharedModule} from 'app/shared/shared.module';
import {AppRoutingModule} from 'app/app-routing.module';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';

// Register locale data
registerLocaleData(localeFr, 'fr-FR');


@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        SharedModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        TreeModule.forRoot(),
        EnerbimCommonsDatepickerModule,
        EnerbimCommonsNotificationModule.forRoot(),
        EnerbimCommonsConfirmationModule.forRoot(),
        EnerbimCommonsTreeModule.forRoot(),
        EnerbimCommonsAuthenticationModule.forRoot(),
        EnerbimCommonsHttpModule.forRoot(),
        EnerbimCommonsMarkdownModule.forRoot(),
        EnerbimCommonsAppInfoModule.forRoot(),
    ],
    providers: [
        // Intercepteurs HTTP
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthExpiredInterceptor,
            multi: true
        },
        // Locale de l'application
        {
            provide: LOCALE_ID,
            useValue: 'fr-FR'
        },
        // HammerJS
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: GestureConfig
        },
        // Configuration Angular Material
        // -> look & feel
        {
            provide: MAT_TABS_CONFIG,
            useValue: {animationDuration: '0ms'}
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {appearance: 'legacy'}
        },
        {
            provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
            useValue: {appearance: 'legacy'}
        },
        // -> paginator en français
        {
            provide: MatPaginatorIntl,
            useClass: MatPaginatorI18nFr
        },
        // -> perfect scrollbar
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: {
                minScrollbarLength: 25
            }
        }
    ],
    bootstrap: [AppComponent],
    exports: [
        MatDialogModule,
        MatCardModule,
        MatSelectModule,
        MatListModule,
        MatExpansionModule,
        MatSlideToggleModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
